import { z } from 'zod';
import { useAPIQuery } from '../APIProvider';
import { useThumbnailUrl } from '../../graph/hooks/onedrive';

const Category = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  longDescription: z.string().optional(),
  coverImage: z.string().optional(),
  coverImageDriveId: z.string().optional(),
  icon: z.string().optional()
});

export type CategoryType = z.infer<typeof Category>;

const useCategoriesQuery = () => {
  return useAPIQuery<CategoryType[]>([`/categories`]);
};

export const useCategories = () => {
  const [result] = useCategoriesQuery();

  return (result || []) as CategoryType[];
};

export const useCategoryDetails = (id: string) => {
  const allDetails = useCategories();
  const categoryData = allDetails.find(d => d.id === id);

  if (!categoryData) {
    throw Error('Could not get category details');
  }

  const thumbnailUrl = useThumbnailUrl(categoryData.coverImageDriveId);

  const imageUrl = thumbnailUrl || categoryData.coverImage;

  return { categoryData, imageUrl };
};
